module.exports = __webpack_public_path__ + "frame-59ed99bf/lebenslauf-logo-light-1738c5ecff0dda94c9d473d232b91240.svg";